import { GO } from './product-util';
import { UserOrderDetails } from '../../features/order-history/order-history.interface';
import { html, TemplateResult } from 'lit';
import { isMhGoItem } from './order-util';
import { isVirtualLabsItem, VIRTUAL_LABS } from '../../features/virtual-labs/utils/virtual-labs.util';

/**
 * Gets the access message for the access type.
 *
 * @param accessType
 */
export function getAccessMessage(accessType: string): string {
  return `Access ${accessType} through your school account (Blackboard, Canvas, D2L, Moodle, etc.)`;
}

/**
 * Gets the access type for the given order item.
 *
 * @param item
 */
export function getAccessType(item: UserOrderDetails) {
  return isMhGoItem(item) ? GO : isVirtualLabsItem(item) ? VIRTUAL_LABS : null;
}

/**
 * Renders an html version of the access message for order history and my digital product pages.
 *
 * @param accessType
 */
export function renderAccessMessage(accessType: string): TemplateResult {
  return html` <div class="fw-bold">${getAccessMessage(accessType)}</div> `;
}
